import { EAutomationAnywhereConnActions, AutomationAnywhereConnActions } from '../actions/rpa-automation-anywhere-conn.actions';
import { isLoading } from '../../../../security/security-authentication/store/selectors/authentication.selectors';
import { IRpaConnectionAutomationAnywhereState } from 'app/rpa-bots/core/IRpaBots';

export const initialStateRpaAutomationAnywhereState: IRpaConnectionAutomationAnywhereState = {
    isLoadingList: false,
    isLoadingDetail: false,
    isLoadingDevices:false,
    isLoadingBots:false,
    isLoadingPoolDevices:false,
    isLoadingUsers:false,
    connectors: [],
    currentConnector: null,
    currentConnectorBots: null,
    currentConnectorDevices: null,
    currentBotsProcesses:null,
    currentRpaPoolDevices:null,
    currentVersionRpa:null,
    currentRpaUsers:null

}

export function RpaAutomationAnywhereReducers(
         state = initialStateRpaAutomationAnywhereState,
         action: AutomationAnywhereConnActions
       ): IRpaConnectionAutomationAnywhereState {
         switch (action.type) {
           case EAutomationAnywhereConnActions.AutomationAnywhereConnList: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingList: true
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.AutomationAnywhereConnListSuccess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingList: false,
               connectors: _.orderBy([...action.payload], p => p.name)
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.GetAutomationAnywhereDevices: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDevices: true
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.GetAutomationAnywherePoolDevices: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingPoolDevices: true
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.GetAutomationAnywhereUsers: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingUsers: true
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.GetAutomationAnywhereBots: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingBots: true
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.SetAABotsSuccess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingBots: false,
               currentConnectorBots: action.payload
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.SetAADevicesSuccess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDevices: false,
               currentConnectorDevices: action.payload
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.SetAAPoolDevicesSuccess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingPoolDevices: false,
               currentRpaPoolDevices: action.payload
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.SetAAUsersSuccess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingUsers: false,
               currentRpaUsers: action.payload
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.UpdateAutomationAnywhereBotProcess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               currentBotsProcesses: state.currentBotsProcesses.map(
                 (currentBot, i) =>
                   currentBot.id === action.payload.id
                     ? { ...currentBot }
                     : currentBot
               )
             };
             return newState;
           }
           case EAutomationAnywhereConnActions.GetCurrentAutomationAnywhereConn: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDetail: true
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.GetCurrentAutomationAnywhereConnSuccess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDetail: false,
               currentConnector: { ...action.payload },
               currentBotsProcesses: { ...action.payload.bots }
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.UpdateAutomationAnywhereConn: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDetail: true
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.UpdateAutomationAnywhereConnSuccess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDetail: false
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.TestAutomationAnywhereConn: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDetail: true
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.TestAutomationAnywhereConnSuccess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDetail: false
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.GetVersionAutomationAnywhere: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDetail: true
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.GetVersionAutomationAnywhereSuccess: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               isLoadingDetail: false,
               currentVersionRpa: action.payload
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.ResetDeviceBotSelection: {
             const newState: IRpaConnectionAutomationAnywhereState = {
               ...state,
               currentConnectorBots: null,
               currentConnectorDevices: null,
               currentRpaPoolDevices: null,
               currentRpaUsers: null
             };
             return newState;
           }

           case EAutomationAnywhereConnActions.ResetAutomationAnywhereState: {
             return initialStateRpaAutomationAnywhereState;
           }
           default: {
             return state;
           }
         }
       }
